// this list is exhaustive per the data in the stage+prod `lead_sources` typesense collections
// as of 05/13/2025
export const SetSources = [
  "setbio",
  "setfan",
  "setlive",

  // deprecated events
  "livestream",
  "nextsong",
  "meetgreet",
  "meetgreetevent",
  "meetgreetevents",
  "settheset",
  "shoutout",
  "shoutouts",
  /**
   * @deprecated - use `setbio` instead
   */
  "set.bio",
] as const;
export type SetSource = (typeof SetSources)[number];
